module.exports = __webpack_public_path__ + "static/media/ic_arrow_r.b3f0897f.svg";